import { render, staticRenderFns } from "./legal-modal.vue?vue&type=template&id=61214270"
import script from "./legal-modal.vue?vue&type=script&lang=js"
export * from "./legal-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61214270')) {
      api.createRecord('61214270', component.options)
    } else {
      api.reload('61214270', component.options)
    }
    module.hot.accept("./legal-modal.vue?vue&type=template&id=61214270", function () {
      api.rerender('61214270', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Distribution/legal-modal.vue"
export default component.exports